import React, {useEffect, useState} from "react";
import Cookies from "js-cookie";
import {Box, Button, makeStyles, Paper, Portal, Typography} from "@material-ui/core";
import useSettings from "src/hooks/useSettings";
import {THEMES} from "src/constants";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: 420,
        position: "fixed",
        top: 0,
        right: 0,
        margin: theme.spacing(3),
        outline: "none",
        zIndex: 2000,
        padding: theme.spacing(2)
    }
}));

const SettingsNotification = () => {
    const classes = useStyles();
    const [isOpen, setOpen] = useState(false);
    const {settings, saveSettings} = useSettings();
    const {t} = useTranslation("notifications");

    const handleSwitch = () => {
        const theme = settings.theme === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK;
        saveSettings({theme: theme});
        Cookies.set("settingsUpdated", "true");
        setOpen(false);
    };

    const handleClose = () => {
        Cookies.set("settingsUpdated", "true");
        setOpen(false);
    };

    useEffect(() => {
        const settingsUpdated = Cookies.get("settingsUpdated");

        if (!settingsUpdated) {
            setOpen(true);
        }
    }, []);

    if (!isOpen) {
        return null;
    }

    return (
        <Portal>
            <Paper className={classes.root} elevation={3}>
                <Typography variant="h4" color="textPrimary" gutterBottom>
                    {t("settings.title")}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {t("settings.text")}
                </Typography>
                <Box mt={2} display="flex" justifyContent="space-between">
                    <Button onClick={handleClose}>{t("settings.closeCta")}</Button>
                    <Button color="secondary" variant="contained" onClick={handleSwitch}>
                        {t("settings.switchCta")}
                    </Button>
                </Box>
            </Paper>
        </Portal>
    );
};

export default SettingsNotification;
